import {dateUtils, logging} from "@/utils/utils";

export default function salesRecordsApis($apiInstance, $store) {
    return {
        getSubscriptions: async (params, success, fail) => {
            // const {startDate, endDate} = params
            return $apiInstance.post('/subscriptions', params)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                })
        },
        authorizationCard: async (cardId, success, fail) => {
            return $apiInstance.post(`/subscriptions/${cardId}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                })
        },
        
        // 거래처 검색 API
        getClientList: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.post(`/companies/list/contract/v2`, params)
                .then((response) => {
                    success(response);
                }, (error) => {
                    console.log(error);
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 카드 유효성 검사 API 호출
        checkCardValidity: async (cardInfo, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.post('/subscription-centerflows/check/card', cardInfo)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 센터플로우 구독 API 호출 메서드
        // 구독 목록 조회
        getCenterflowSubscriptions: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            
            let url = '/subscription-centerflows';
            const queryParams = [];
            
            if (params.page) queryParams.push(`page=${params.page}`);
            if (params.limit) queryParams.push(`limit=${params.limit}`);
            if (params.hospitalName) queryParams.push(`hospitalName=${encodeURIComponent(params.hospitalName)}`);
            if (params.status) queryParams.push(`status=${params.status}`);
            if (params.hospitalType) queryParams.push(`hospitalType=${params.hospitalType}`);
            if (params.startDate) queryParams.push(`startDate=${params.startDate}`);
            if (params.endDate) queryParams.push(`endDate=${params.endDate}`);
            
            if (queryParams.length > 0) {
                url += '?' + queryParams.join('&');
            }
            
            return $apiInstance.get(url)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 구독 상세 조회
        getCenterflowSubscription: async (id, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.get(`/subscription-centerflows/${id}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 구독 생성
        createCenterflowSubscription: async (data, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.post('/subscription-centerflows', data)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 구독 수정
        updateCenterflowSubscription: async (id, data, success, fail) => {
            $store.commit('setIsLoading', true);
            
            console.log('API에 전송되는 수정 데이터:', data); // 디버깅용 로그
            
            try {
                const response = await $apiInstance.put(`/subscription-centerflows/${id}`, data);
                success(response);
            } catch (error) {
                console.error('구독 수정 API 오류:', error);
                console.error('오류 세부 정보:', error.response?.data);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 구독 삭제 (소프트 삭제)
        deleteCenterflowSubscription: async (id, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.delete(`/subscription-centerflows/${id}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 카드 삭제
        removeCenterflowCardInfo: async (id, cardNumber, options = {}, success, fail) => {
            $store.commit('setIsLoading', true);
            
            try {
                const response = await $apiInstance.delete(`/subscription-centerflows/${id}/card-info/${cardNumber}`, {
                    data: options // DELETE 요청에서는 body를 data 속성으로 전달해야 함
                });
                success(response);
            } catch (error) {
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 센터플로우 구독에 새 카드 추가
        addCenterflowCardInfo: async (id, cardData, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.post(`/subscription-centerflows/${id}/add-card`, cardData)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 기본 카드 설정
        setDefaultCenterflowCard: async (id, cardNumber, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.put(`/subscription-centerflows/${id}/card-info/default?cardNumber=${encodeURIComponent(cardNumber)}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 카드 활성화/비활성화
        toggleCenterflowCardActive: async (id, cardNumber, isActive, success, fail) => {
            $store.commit('setIsLoading', true);
            
            return $apiInstance.put(`/subscription-centerflows/${id}/card-info/${cardNumber}/toggle-active?isActive=${isActive}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        
        // 결제 처리 API
        processCenterflowPayment: async (id, paymentData = {}, success, fail) => {
            $store.commit('setIsLoading', true);
            
            try {
                const response = await $apiInstance.post(`/subscription-centerflows/${id}/process-payment`, paymentData);
                success(response);
            } catch (error) {
                console.error('결제 처리 API 오류:', error);
                console.error('오류 세부 정보:', error.response?.data);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        }
    }
}